import React from "react";
import { Dialog } from "primereact/dialog";
import { Link } from "react-router-dom";

const ActionErrorMsg = ({
	heading,
	message,
	children,
	action,
	className = undefined,
}) => {
	const [visible, setVisible] = React.useState(false);

	return (
		<>
			<button
				type="button"
				className={className}
				onClick={() => setVisible(true)}
				aria-haspopup="dialog"
				aria-expanded={visible}
			>
				{children}
			</button>

			<Dialog
				visible={visible}
				header={<p className="text-lg">{heading}</p>}
				onHide={() => setVisible(false)}
				showHeader={true}
			>
				<div className="py-3">
					<div className="mt-3">
						<p className="text-center mx-auto max-w-sm text-gray-700 leading-relaxed">
							{message}
						</p>
					</div>

					{action && (
						<div className="mx-auto flex justify-center mt-5">
							<Link
								to={action.link}
								className="bg-akgreener text-white rounded-full px-4 py-2 font-medium hover:bg-akgreener/90 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-akgreener/50"
							>
								{action.label}
							</Link>
						</div>
					)}
				</div>
			</Dialog>
		</>
	);
};

export default ActionErrorMsg;
